export default {
  props: {
    maxWidth: {
      type: String,
      default: 'desktop-m',
      validator: (prop) => ['desktop', 'desktop-m'].includes(prop),
    },
  },
}
